import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dad31264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kam-kam002" }
const _hoisted_2 = { class: "sheet" }
const _hoisted_3 = { class: "sheet-row sheet-row-3 no-vertical-lines" }
const _hoisted_4 = { class: "sheet-cell" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-title" }, "Bedrijfsgegevens o.a.", -1))
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "field-label" }
const _hoisted_8 = {
  key: 0,
  class: "required"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "field-label" }
const _hoisted_11 = {
  key: 0,
  class: "required"
}
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "field-label" }
const _hoisted_14 = {
  key: 0,
  class: "required"
}
const _hoisted_15 = { class: "sheet-cell" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-title" }, "Uit te voeren werkzaamheden", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtle" }, "Fase", -1))
const _hoisted_18 = { class: "checkbox-column" }
const _hoisted_19 = { class: "sheet-cell" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-title" }, "Project", -1))
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "field-label" }
const _hoisted_23 = {
  key: 0,
  class: "required"
}
const _hoisted_24 = { class: "field" }
const _hoisted_25 = { class: "field-label" }
const _hoisted_26 = {
  key: 0,
  class: "required"
}
const _hoisted_27 = { class: "field" }
const _hoisted_28 = { class: "field-label" }
const _hoisted_29 = {
  key: 0,
  class: "required"
}
const _hoisted_30 = { class: "field" }
const _hoisted_31 = { class: "field-label" }
const _hoisted_32 = {
  key: 0,
  class: "required"
}
const _hoisted_33 = { class: "sheet-row sheet-row-3 no-vertical-lines" }
const _hoisted_34 = { class: "sheet-cell" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-title" }, "Eindverantwoordelijke", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtle" }, "Directeur / bedrijfsleider / projectleider", -1))
const _hoisted_37 = { class: "field mt8" }
const _hoisted_38 = { class: "field-label" }
const _hoisted_39 = {
  key: 0,
  class: "required"
}
const _hoisted_40 = { class: "field" }
const _hoisted_41 = { class: "field-label" }
const _hoisted_42 = {
  key: 0,
  class: "required"
}
const _hoisted_43 = { class: "sheet-cell" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-title" }, "Aanwezig op het werk", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtle" }, "Uitvoerder / voorman", -1))
const _hoisted_46 = { class: "field mt8" }
const _hoisted_47 = { class: "field-label" }
const _hoisted_48 = {
  key: 0,
  class: "required"
}
const _hoisted_49 = { class: "field" }
const _hoisted_50 = { class: "field-label" }
const _hoisted_51 = {
  key: 0,
  class: "required"
}
const _hoisted_52 = { class: "sheet-cell" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-title" }, "Opmerkingen", -1))
const _hoisted_54 = { class: "sheet-row sheet-row-3" }
const _hoisted_55 = { class: "sheet-cell" }
const _hoisted_56 = { class: "field flex-column" }
const _hoisted_57 = { class: "field-label" }
const _hoisted_58 = {
  key: 0,
  class: "required"
}
const _hoisted_59 = { class: "sheet-cell" }
const _hoisted_60 = { class: "field flex-column" }
const _hoisted_61 = { class: "field-label" }
const _hoisted_62 = {
  key: 0,
  class: "required"
}
const _hoisted_63 = { class: "sheet-cell" }
const _hoisted_64 = { class: "field flex-column" }
const _hoisted_65 = { class: "field-label" }
const _hoisted_66 = {
  key: 0,
  class: "required"
}
const _hoisted_67 = { class: "table-wrap" }
const _hoisted_68 = { class: "simple-table" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"33%"} }, "Onderaannemer"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"52%"} }, "Uit te voeren werkzaamheden"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, "1e verantwoordelijke"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"2%"} }, " ")
  ])
], -1))
const _hoisted_70 = { class: "center-cell" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "muted"
}, "Nog geen onderaannemers toegevoegd.", -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = {
  key: 0,
  class: "actions"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note purple" }, " WIJ ACCEPTEREN GEEN ALGEMENE V&G-PLANNEN VAN ONDERAANNEMERS. ", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note-extra" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Uw onderaannemers conformeren zich net als u aan het V&G-plan van Thunnissen Bouw met de datum"),
  /*#__PURE__*/_createElementVNode("div", null, "U houdt zelf toezicht op naleving door uw eigen werknemers en die van uw onderaannemers."),
  /*#__PURE__*/_createElementVNode("div", null, "Bij het startgesprek met de uitvoerder 2 weken voor aanvang worden de PRIE-TRA besproken.")
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "static-lines" }, [
  /*#__PURE__*/_createElementVNode("div", null, "U verzorgt zelf (project gerichte) voorlichting en instructie aan eigen werknemers en onderaannemers."),
  /*#__PURE__*/_createElementVNode("div", null, "Kopieën hiervan mailen aan uitvoerder Thunnissen.")
], -1))
const _hoisted_78 = { class: "mt10" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Toelichting", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "static-lines" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Welke aanvullende BHV-maatregelen heeft u voor dit project getroffen:")
], -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "BHV’er dhr. / mevr.", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Blusmiddelen", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "static-lines" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Welke arbo-risico’s die niet zijn genoemd in V&G-plan opdrachtgever zijn verbonden aan uw werkzaamheden op dit project? Risico’s voor anderen dan eigen medewerkers en publiek vult u ook in. ")
], -1))
const _hoisted_84 = { class: "table-wrap mt10" }
const _hoisted_85 = { class: "simple-table" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }, "Arbo risico oorzaak / bron"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"45%"} }, "Concrete maatregelen op de werkplek"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "Leveren door / Aanbrengen door"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, "In stand houden door"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"2%"} }, " ")
  ])
], -1))
const _hoisted_87 = { key: 0 }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "muted"
}, "Nog geen risico’s toegevoegd.", -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = {
  key: 0,
  class: "actions"
}
const _hoisted_91 = { class: "field flex-column signature-area" }
const _hoisted_92 = { class: "signature-top" }
const _hoisted_93 = { class: "sig-name" }
const _hoisted_94 = {
  key: 0,
  class: "required"
}
const _hoisted_95 = { class: "sig-date" }
const _hoisted_96 = {
  key: 0,
  class: "required"
}
const _hoisted_97 = { class: "sig-pad" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Handtekening", -1))
const _hoisted_99 = { style: {"margin-top":"8px"} }
const _hoisted_100 = ["src", "alt"]
const _hoisted_101 = {
  key: 0,
  class: "actions",
  style: {"margin-top":"16px"}
}

import { computed, ref, watch, nextTick } from 'vue'
import type { ComputedRef } from 'vue'
import { DeleteOutlined } from '@ant-design/icons-vue'
import kamStore from '@/stores/kam.ts'
import { KAMFormStatuses } from '@/helpers/kamFormStates'
import SignatureField from '@/components/SignatureField.vue'
import {
  createDatePickerProxy,
  ensureArrayField,
  ensureObjectField,
  filterOptionByLabel,
  findPersonOptionByValue,
  getArrayField,
  getStoredPersonSelectionValue,
  hasMeaningfulValue,
  mapPeopleToOptions,
  queuePendingUpload,
  removeTemporaryMedia,
  useDirtySnapshot,
  useConditionalRequiredFields
} from '@/helpers/kamFormUtils'
import type { PersonLikeOption, UnknownRecord } from '@/helpers/kamFormUtils'

type SubcontractorRow = { name: string, work: string, responsible: boolean }
type RiskRow = { risk: string, measures: string, supplyBy: string, maintainBy: string }
type SignatureMedia = string | { id?: string | number, url?: string, file_name?: string, uploading?: boolean, failed?: boolean } | null
type Answers = UnknownRecord & {
  companyName?: string
  projectName?: string
  projectReference?: string
  projectAddress?: string
  projectCity?: string
  planDate?: Date | string | null
  signatureDate?: Date | string | null
  signatureName?: string
  signature?: string[]
  media?: UnknownRecord & { signature?: SignatureMedia }
  subcontractors?: SubcontractorRow[]
  risks?: RiskRow[]
  onSiteResponsibleName?: string
  onSiteResponsiblePhone?: string
  onSiteResponsibleId?: string | number | null
  vgCoordinatorName?: string
  vgCoordinatorId?: string | number | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'KAM002-v1',
  props: {
    answers: null,
    editable: { type: Boolean },
    siteManagers: null,
    employees: null
  },
  emits: ["changed", "dirty", "required-filled"],
  setup(__props: any, { emit }: { emit: ({(e: 'changed'): void, (e: 'dirty', value: boolean): void, (e: 'required-filled', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  answers: Answers
  editable: boolean
  siteManagers: PersonLikeOption[]
  employees?: PersonLikeOption[]
};





const requiredFields = [
  'companyName',
  'companyAddress',
  'companyCity',
  'projectName',
  'projectReference',
  'projectAddress',
  'projectCity',
  'finalResponsibleName',
  'finalResponsiblePhone',
  'onSiteResponsibleName',
  'onSiteResponsiblePhone',
  'planDiscussedWith',
  'vgCoordinatorName',
  'planDate',
  'signatureName',
  'signatureDate'
]
const saving = ref(false)

const formAnswers = computed(() => {
  const storeAnswers = kamStore().kamForm?.answers as Answers | undefined
  return (storeAnswers ?? props.answers) as Answers
}) as ComputedRef<Answers>

const { capture } = useDirtySnapshot(formAnswers as ComputedRef<UnknownRecord>, (value) => emit('dirty', value))
const allRequiredFilled = useConditionalRequiredFields(
  () => requiredFields.every((field) => hasMeaningfulValue(formAnswers.value, field)),
  (value) => emit('required-filled', value)
)

const siteManagerOptions = computed(() => mapPeopleToOptions(props.siteManagers))
const employeesOptions = computed(() => mapPeopleToOptions(props.employees ?? []))
const subcontractors = computed(() => getArrayField<SubcontractorRow>(formAnswers.value, 'subcontractors'))
const risks = computed(() => getArrayField<RiskRow>(formAnswers.value, 'risks'))

const planDateProxy = createDatePickerProxy(formAnswers, 'planDate', 'YYYY-MM-DD', 'today')
const signatureDateProxy = createDatePickerProxy(formAnswers, 'signatureDate', 'YYYY-MM-DD', 'today')

const selectedOnSiteResponsible = ref<string | number | null>(null)
const selectedVgCoordinator = ref<string | number | null>(null)

watch(selectedOnSiteResponsible, (newValue) => {
  const value = newValue == null ? '' : String(newValue)
  if (!value) {
    formAnswers.value.onSiteResponsibleName = ''
    formAnswers.value.onSiteResponsiblePhone = ''
    formAnswers.value.onSiteResponsibleId = null
    return
  }

  const selectedManager = findPersonOptionByValue(siteManagerOptions.value, value)
  if (selectedManager) {
    formAnswers.value.onSiteResponsibleName = selectedManager.label
    formAnswers.value.onSiteResponsiblePhone = selectedManager.phone ?? ''
    formAnswers.value.onSiteResponsibleId = selectedManager.id
    return
  }

  formAnswers.value.onSiteResponsibleName = value
  formAnswers.value.onSiteResponsiblePhone = ''
  formAnswers.value.onSiteResponsibleId = null
})

watch(selectedVgCoordinator, (newValue) => {
  const value = newValue == null ? '' : String(newValue)
  if (!value) {
    formAnswers.value.vgCoordinatorName = ''
    formAnswers.value.vgCoordinatorId = null
    return
  }

  const selectedEmployee = findPersonOptionByValue(employeesOptions.value, value)
  if (selectedEmployee) {
    formAnswers.value.vgCoordinatorName = selectedEmployee.label
    formAnswers.value.vgCoordinatorId = selectedEmployee.id
    return
  }

  formAnswers.value.vgCoordinatorName = value
  formAnswers.value.vgCoordinatorId = null
})

watch(() => kamStore().kamForm, async (newForm) => {
  if (!newForm?.project) return

  if (!newForm.answers || Array.isArray(newForm.answers)) newForm.answers = {}
  const answersObj = newForm.answers as Answers
  const project = newForm.project

  if (!answersObj.projectReference && project.reference) answersObj.projectReference = project.reference
  if (!answersObj.projectName && project.name) answersObj.projectName = project.name
  if (!answersObj.projectCity && project.city) answersObj.projectCity = project.city
  if (!answersObj.planDate) answersObj.planDate = new Date().toISOString()
  if (!answersObj.signatureDate) answersObj.signatureDate = new Date().toISOString()
  ensureObjectField(answersObj, 'media')

  selectedOnSiteResponsible.value = getStoredPersonSelectionValue(siteManagerOptions.value, {
    name: answersObj.onSiteResponsibleName,
    id: answersObj.onSiteResponsibleId,
    phone: answersObj.onSiteResponsiblePhone
  })

  selectedVgCoordinator.value = getStoredPersonSelectionValue(employeesOptions.value, {
    name: answersObj.vgCoordinatorName,
    id: answersObj.vgCoordinatorId
  })

  await nextTick()
  capture(newForm.answers ?? {})
}, { immediate: true })

function addSubcontractor () {
  ensureArrayField<SubcontractorRow>(formAnswers.value, 'subcontractors').push({ name: '', work: '', responsible: false })
}

function removeSubcontractorAt (index: number) {
  ensureArrayField<SubcontractorRow>(formAnswers.value, 'subcontractors').splice(index, 1)
}

function addRiskRow () {
  ensureArrayField<RiskRow>(formAnswers.value, 'risks').push({ risk: '', measures: '', supplyBy: '', maintainBy: '' })
}

function removeRiskAt (index: number) {
  ensureArrayField<RiskRow>(formAnswers.value, 'risks').splice(index, 1)
}

function onSignatureSave (payload: File) {
  if (!kamStore().kamForm) return

  const signatureList = ensureArrayField<string>(formAnswers.value, 'signature')
  signatureList.splice(0, signatureList.length)
  ensureObjectField(formAnswers.value, 'media').signature = queuePendingUpload(kamStore().kamForm as Record<string, unknown>, 'signature', payload)
}

function onSignatureCleared () {
  const mediaSignature = ensureObjectField(formAnswers.value, 'media').signature as SignatureMedia
  formAnswers.value.signature = []

  if (mediaSignature && typeof mediaSignature === 'object' && typeof mediaSignature.id === 'string' && mediaSignature.id.startsWith('tmp-') && kamStore().kamForm) {
    removeTemporaryMedia(kamStore().kamForm as Record<string, unknown>, mediaSignature.id)
  }

  delete ensureObjectField(formAnswers.value, 'media').signature
}

const signatureName = computed(() => {
  if (typeof formAnswers.value.signatureName === 'string' && formAnswers.value.signatureName.length > 0) {
    return formAnswers.value.signatureName
  }
  return `KAM_${kamStore().kamForm?.id ?? ''}_Handtekening`
})

function getSignatureDataUrl () {
  const mediaSignature = ensureObjectField(formAnswers.value, 'media').signature
  if (typeof mediaSignature === 'string' && mediaSignature.length > 0) return mediaSignature
  if (mediaSignature && typeof mediaSignature === 'object' && !Array.isArray(mediaSignature) && typeof mediaSignature.url === 'string') {
    return mediaSignature.url
  }

  const signatureList = Array.isArray(formAnswers.value.signature) ? formAnswers.value.signature : []
  return typeof signatureList[0] === 'string' ? signatureList[0] : ''
}

function isRequired (key:string) {
  return requiredFields.includes(key)
}

function filterUsers (input: string, option?: { label?: string }) {
  return filterOptionByLabel(input, option)
}

function onSiteManagerCleared () {
  formAnswers.value.onSiteResponsibleName = ''
  formAnswers.value.onSiteResponsiblePhone = ''
  formAnswers.value.onSiteResponsibleId = null
  selectedOnSiteResponsible.value = null
}

function onVgCoordinatorCleared () {
  formAnswers.value.vgCoordinatorName = ''
  formAnswers.value.vgCoordinatorId = null
  selectedVgCoordinator.value = null
}

const definitiveEnabled = computed(() => {
  if (!props.editable || !allRequiredFilled.value) return false

  return getSignatureDataUrl().length > 0
})

function onDefinitiveSave () {
  try {
    if (kamStore().kamForm) kamStore().kamForm.status = KAMFormStatuses.Closed
    emit('changed')
  } catch (e) {}
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      class: "mt16",
      loading: saving.value,
      title: "VGM-deelplan onderaannemer"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode("Naam: "),
                  (isRequired('companyName'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).companyName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formAnswers).companyName) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Naam bedrijf"
                }, null, 8, ["value", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode("Adres: "),
                  (isRequired('companyAddress'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).companyAddress,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formAnswers).companyAddress) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Straat en huisnummer"
                }, null, 8, ["value", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createTextVNode("Plaats: "),
                  (isRequired('companyCity'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).companyCity,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formAnswers).companyCity) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Plaats / stad"
                }, null, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              _createVNode(_component_a_checkbox_group, {
                value: _unref(formAnswers).workPhases,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formAnswers).workPhases) = $event)),
                disabled: !__props.editable
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_checkbox, { value: "ground" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Grond")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: "foundation" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Fundering")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: "shell" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ruwbouw")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: "finish" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Afbouw")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["value", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createTextVNode("Projectnaam: "),
                  (isRequired('projectName'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).projectName,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formAnswers).projectName) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Projectnaam"
                }, null, 8, ["value", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createTextVNode("Nummer: "),
                  (isRequired('projectReference'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).projectReference,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formAnswers).projectReference) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Projectnummer"
                }, null, 8, ["value", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createTextVNode("Adres: "),
                  (isRequired('projectAddress'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).projectAddress,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formAnswers).projectAddress) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Projectadres"
                }, null, 8, ["value", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createTextVNode("Plaats: "),
                  (isRequired('projectCity'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).projectCity,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formAnswers).projectCity) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Plaats / stad"
                }, null, 8, ["value", "disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createTextVNode("Naam: "),
                  (isRequired('finalResponsibleName'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).finalResponsibleName,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formAnswers).finalResponsibleName) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Naam eindverantwoordelijke"
                }, null, 8, ["value", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createTextVNode("Mobiel tel: "),
                  (isRequired('finalResponsiblePhone'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).finalResponsiblePhone,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formAnswers).finalResponsiblePhone) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Telefoonnummer"
                }, null, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createTextVNode("Naam: "),
                  (isRequired('onSiteResponsibleName'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: selectedOnSiteResponsible.value,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((selectedOnSiteResponsible).value = $event)),
                  disabled: !__props.editable,
                  placeholder: "Naam uitvoerder / voorman",
                  onClear: onSiteManagerCleared
                }, null, 8, ["value", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createTextVNode("Mobiel tel: "),
                  (isRequired('onSiteResponsiblePhone'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).onSiteResponsiblePhone,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formAnswers).onSiteResponsiblePhone) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Telefoonnummer"
                }, null, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createVNode(_component_a_textarea, {
                value: _unref(formAnswers).remarks,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formAnswers).remarks) = $event)),
                disabled: !__props.editable,
                "auto-size": { minRows: 5, maxRows: 10 },
                placeholder: "Opmerkingen / toelichting"
              }, null, 8, ["value", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createTextVNode("V&G-plan doorgesproken met: "),
                  (isRequired('planDiscussedWith'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_input, {
                  value: _unref(formAnswers).planDiscussedWith,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formAnswers).planDiscussedWith) = $event)),
                  disabled: !__props.editable,
                  placeholder: "Naam persoon / organisatie"
                }, null, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createTextVNode("(namens de) V&G-coördinator uitvoeringsfase: "),
                  (isRequired('vgCoordinatorName'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_select, {
                  value: selectedVgCoordinator.value,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((selectedVgCoordinator).value = $event)),
                  disabled: !__props.editable,
                  options: _unref(employeesOptions),
                  "filter-option": filterUsers,
                  "field-names": { label: 'label', value: 'id' },
                  "show-search": "",
                  placeholder: "Naam VGM-coördinator",
                  onClear: onVgCoordinatorCleared,
                  allowClear: ""
                }, null, 8, ["value", "disabled", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createTextVNode("Datum: "),
                  (isRequired('planDate'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_66, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_date_picker, {
                  value: _unref(planDateProxy),
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_isRef(planDateProxy) ? (planDateProxy).value = $event : null)),
                  "value-format": "YYYY-MM-DD",
                  format: "DD-MM-YYYY",
                  disabled: !__props.editable,
                  placeholder: "DD-MM-JJJJ",
                  style: {"width":"100%"}
                }, null, 8, ["value", "disabled"])
              ])
            ])
          ])
        ]),
        _createVNode(_component_a_card, {
          size: "small",
          class: "mt16",
          title: "Onderaannemers die u inschakelt op dit project (alleen na toestemming opdrachtgever)"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("table", _hoisted_68, [
                _hoisted_69,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subcontractors), (row, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_a_input, {
                          value: row.name,
                          "onUpdate:value": ($event: any) => ((row.name) = $event),
                          disabled: !__props.editable,
                          placeholder: "Naam onderaannemer"
                        }, null, 8, ["value", "onUpdate:value", "disabled"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_a_textarea, {
                            value: row.work,
                            "onUpdate:value": ($event: any) => ((row.work) = $event),
                            disabled: !__props.editable,
                            "auto-size": true,
                            placeholder: "Omschrijving werkzaamheden"
                          }, null, 8, ["value", "onUpdate:value", "disabled"])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_70, [
                        _createVNode(_component_a_checkbox, {
                          checked: row.responsible,
                          "onUpdate:checked": ($event: any) => ((row.responsible) = $event),
                          disabled: !__props.editable
                        }, null, 8, ["checked", "onUpdate:checked", "disabled"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_a_popconfirm, {
                          placement: "bottomRight",
                          title: "Weet je zeker dat je deze onderaannemer wilt verwijderen?",
                          "ok-text": "Ja, verwijderen",
                          "cancel-text": "Nee",
                          onConfirm: ($event: any) => (removeSubcontractorAt(idx))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "text",
                              danger: "",
                              disabled: !__props.editable,
                              title: "Rij verwijderen"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(DeleteOutlined))
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"])
                      ])
                    ]))
                  }), 128)),
                  (_unref(subcontractors).length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_71, _hoisted_73))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (__props.editable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _createVNode(_component_a_button, { onClick: addSubcontractor }, {
                    default: _withCtx(() => [
                      _createTextVNode("Rij toevoegen")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _hoisted_75,
            _hoisted_76
          ]),
          _: 1
        }),
        _createVNode(_component_a_card, {
          size: "small",
          class: "mt16",
          title: "Voorlichting en instructie"
        }, {
          default: _withCtx(() => [
            _hoisted_77,
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createVNode(_component_a_textarea, {
                value: _unref(formAnswers).instructionNotes,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_unref(formAnswers).instructionNotes) = $event)),
                disabled: !__props.editable,
                "auto-size": { minRows: 3, maxRows: 6 },
                placeholder: "Korte toelichting / instructies"
              }, null, 8, ["value", "disabled"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_card, {
          size: "small",
          class: "mt16",
          title: "Eerste hulp"
        }, {
          default: _withCtx(() => [
            _hoisted_80,
            _createVNode(_component_a_row, {
              gutter: [16, 16],
              class: "mt8"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _hoisted_81,
                    _createVNode(_component_a_input, {
                      value: _unref(formAnswers).bhvPerson,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(formAnswers).bhvPerson) = $event)),
                      disabled: !__props.editable,
                      placeholder: "Naam BHV'er"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _hoisted_82,
                    _createVNode(_component_a_input, {
                      value: _unref(formAnswers).extinguishers,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(formAnswers).extinguishers) = $event)),
                      disabled: !__props.editable,
                      placeholder: "Type / aantal blusmiddelen"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_card, {
          size: "small",
          class: "mt16",
          title: "Risico’s en maatregelen"
        }, {
          default: _withCtx(() => [
            _hoisted_83,
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("table", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(risks), (row, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_a_textarea, {
                            value: row.risk,
                            "onUpdate:value": ($event: any) => ((row.risk) = $event),
                            disabled: !__props.editable,
                            "auto-size": true,
                            placeholder: "Arbo risico oorzaak / bron"
                          }, null, 8, ["value", "onUpdate:value", "disabled"])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_a_textarea, {
                            value: row.measures,
                            "onUpdate:value": ($event: any) => ((row.measures) = $event),
                            disabled: !__props.editable,
                            "auto-size": true,
                            placeholder: "Concrete maatregelen op de werkplek"
                          }, null, 8, ["value", "onUpdate:value", "disabled"])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_a_input, {
                          value: row.supplyBy,
                          "onUpdate:value": ($event: any) => ((row.supplyBy) = $event),
                          disabled: !__props.editable,
                          placeholder: "Leveren door / aanbrengen door"
                        }, null, 8, ["value", "onUpdate:value", "disabled"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_a_input, {
                          value: row.maintainBy,
                          "onUpdate:value": ($event: any) => ((row.maintainBy) = $event),
                          disabled: !__props.editable,
                          placeholder: "In stand houden door"
                        }, null, 8, ["value", "onUpdate:value", "disabled"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_a_popconfirm, {
                          placement: "bottomRight",
                          title: "Weet je zeker dat je deze risicoregel wilt verwijderen?",
                          "ok-text": "Ja, verwijderen",
                          "cancel-text": "Nee",
                          onConfirm: ($event: any) => (removeRiskAt(idx))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "text",
                              danger: "",
                              disabled: !__props.editable,
                              title: "Rij verwijderen"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(DeleteOutlined))
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"])
                      ])
                    ]))
                  }), 128)),
                  (_unref(risks).length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_87, _hoisted_89))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (__props.editable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  _createVNode(_component_a_button, { onClick: addRiskRow }, {
                    default: _withCtx(() => [
                      _createTextVNode("Rij toevoegen")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_card, {
          size: "small",
          class: "mt16",
          title: "Ondertekening"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: [16, 16] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("label", null, [
                            _createTextVNode("Naam "),
                            (isRequired('signatureName'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_94, "*"))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_a_input, {
                            value: _unref(formAnswers).signatureName,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(formAnswers).signatureName) = $event)),
                            disabled: !__props.editable,
                            placeholder: "Naam ondertekenaar"
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("label", null, [
                            _createTextVNode("Datum "),
                            (isRequired('signatureDate'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_96, "*"))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_a_date_picker, {
                            value: _unref(signatureDateProxy),
                            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_isRef(signatureDateProxy) ? (signatureDateProxy).value = $event : null)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            disabled: !__props.editable,
                            placeholder: "DD-MM-JJJJ"
                          }, null, 8, ["value", "disabled"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_97, [
                        _hoisted_98,
                        _createElementVNode("div", _hoisted_99, [
                          (__props.editable)
                            ? (_openBlock(), _createBlock(SignatureField, {
                                key: 0,
                                width: "100%",
                                height: "200px",
                                "return-type": "file",
                                "signature-name": _unref(signatureName),
                                "initial-data-url": getSignatureDataUrl(),
                                locked: !!getSignatureDataUrl(),
                                onSignatureSave: onSignatureSave,
                                onSignatureCleared: onSignatureCleared
                              }, null, 8, ["signature-name", "initial-data-url", "locked"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (getSignatureDataUrl())
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: getSignatureDataUrl(),
                                      alt: _unref(formAnswers).signatureName || 'Handtekening',
                                      style: {"max-width":"100%","height":"auto"}
                                    }, null, 8, _hoisted_100))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("Geen handtekening beschikbaar.")
                                    ], 64))
                              ], 64))
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (__props.editable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: onDefinitiveSave,
                disabled: !_unref(definitiveEnabled)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Definitief Opslaan ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})